export default {
  init() {
    var active = $('.dropdown').find('.current-cat');
    $('.dropdown-toggle').text(active.text());
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-resource-database-classic.js